module.exports = __webpack_public_path__ + "static/media/12.d8f21a7f.jpg";